function MediaDurationExceededError(message, maxDuration) {
  this.name = 'Media Duration Exceeds Allowable Duration';
  this.message = message || 'The media is too long.';
  this.maxDuration = maxDuration;
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
  this.stack = new Error().stack;
}

MediaDurationExceededError.prototype = Object.create(Error.prototype);
MediaDurationExceededError.prototype.constructor = MediaDurationExceededError;

export default MediaDurationExceededError;
